import { z } from "zod";
import { EventConnection, EventType } from "../types/logStreamEvent";

export const LogStreamEventSchema = z.object({
    logId: z.string(),
    eventType: z.nativeEnum(EventType),
    connection: z.nativeEnum(EventConnection),
    ip: z.string(),
    ipLocation: z.string().nullable(),
    userAgent: z.string(),
    date: z.coerce.date(),
});

export const LogStreamEventQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(10),
});

export const LogStreamEventResponseSchema = z.object({
    data: z.array(LogStreamEventSchema),
    total: z.number(),
    page: z.number(),
    pageCount: z.number(),
});

export type LogStreamEventQuery = z.infer<typeof LogStreamEventQuerySchema>;
export type LogStreamEventResponse = z.infer<
    typeof LogStreamEventResponseSchema
>;
